import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextLink } from '@vds/buttons';
import { VDSModal as Modal } from './Modal/VDSModal';
import { isExpressCheckout, isDeviceUpgradeFlow, isTitanOneUpgradeFlag } from './Helpers';
import { eventDispatcher } from './Tagging';

const GlobalRibbon = ({ props, pageName }) => {
  const { promoRibbonText, promoRibbonDisclaimer, inCartGNAVRibbon, isGNRT, promoStartTime, promoEndTimer } = props;
  const { '30DayGNAVText': gnavText, '30DayGNAVTextLink': gnavLink, '30DayGNAVModalContent': gnavModalContent } = props;
  const currentDate = Date.now();
  const startTime = Number(promoStartTime);
  const endTime = Number(promoEndTimer);
  const hasValidWindow = Number.isFinite(startTime) && Number.isFinite(endTime) && endTime > startTime;
  const newPromoRibbonActive = hasValidWindow && currentDate > startTime && currentDate < endTime;
  const ribbonText = newPromoRibbonActive ? promoRibbonText : gnavText;
  const ribbonLink = gnavLink;
  const ribbonContent = newPromoRibbonActive ? promoRibbonDisclaimer : gnavModalContent;

  const excludePage = !(
    ['setup', 'payment', 'confirmation', 'appointment', 'registration', 'DeviceUpgrade', 'expresscheckout'].includes(pageName) ||
    isDeviceUpgradeFlow() ||
    isExpressCheckout() ||
    isTitanOneUpgradeFlag()
  );

  const aemCheck = !!((inCartGNAVRibbon || newPromoRibbonActive) && ribbonText && ribbonLink && ribbonContent);
  const validationCheck = aemCheck && excludePage;

  useEffect(() => {
    if (validationCheck && isGNRT) {
      const obj = {
        name: '',
        data: { page: { detail: 'message displayed' } },
        message: "Enjoy our 30-Day Money Back Guarantee. If you're not completely satisfied, get your money back. Exclusions Apply.",
      };
      eventDispatcher('notify', obj);
    }
  }, [validationCheck, isGNRT, pageName]);

  const setView = (value) => {
    if (isGNRT) {
      const objectName = {
        name: !value && 'close',
        data: { page: { detail: 'exclusions apply modal' } },
        message: '',
      };
      eventDispatcher(value ? 'openView' : 'linkClick', objectName);
    }
  };

  return (
    <>
      {validationCheck && (
        <div className="ribbon">
          <div className="ribbonText">
          <span dangerouslySetInnerHTML={{ __html: ribbonText }} />
            &nbsp;
            <Modal
              toggleButton={
                <TextLink surface="light" data-track={isGNRT ? "{type: 'link', name: 'Exclusions Apply'}" : ''}>
                  {ribbonLink}
                </TextLink>
              }
              surface="light"
              fullScreenDialog={false}
              disableAnimation={false}
              disableOutsideClick={false}
              closeButtonId="close_btn"
              onOpenedChange={setView}
            >
              <span className="ribbonModal" dangerouslySetInnerHTML={{ __html: ribbonContent }} />
            </Modal>
          </div>
        </div>
      )}
    </>
  );
};

GlobalRibbon.propTypes = {
  '30DayGNAVText': PropTypes.string,
  '30DayGNAVTextLink': PropTypes.func,
  '30DayGNAVModalContent': PropTypes.bool,
  inCartGNAVRibbon: PropTypes.bool,
  isGNRT: PropTypes.bool,
  pageName: PropTypes.string,
  props: PropTypes.any,
  promoRibbonText: PropTypes.string,
  promoRibbonDisclaimer: PropTypes.string,
  promoStartTime: PropTypes.number,
  promoEndTimer: PropTypes.number,
};

export default GlobalRibbon;
